var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"rounded-circle",attrs:{"height":"200","width":"200","src":_vm.brand.homepageLogo}}),_c('h1',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.brand.name)+" ")]),(_vm.brand.showPoweredBy)?_c('div',{staticClass:"mt-3 text-secondary small"},[_vm._v(" Powered by Findmate ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }